<script setup lang="ts">
import VText from "@magnit/core/src/components/VText/VText.vue";
import type { IProductDetailsBase } from "../types/product-details";
import useProduct from "../composables/useProduct";

const props = defineProps<IProductDetailsBase>();
const { productNutritionFacts } = useProduct(props.product);
</script>

<template>
  <section
    v-if="productNutritionFacts"
    class="product-details-nutrition-facts"
    data-test-id="product-details-nutrition"
  >
    <VText
      :font="{ xs: 'caption-large-accent', l: 'body-large-accent' }"
      class="product-details-nutrition-facts__title"
      color="secondary"
      tag="div"
    >
      {{ productNutritionFacts.name }}
    </VText>
    <div class="product-details-nutrition-facts__list">
      <div
        v-for="(single, index) in productNutritionFacts.parameters"
        :key="index"
        class="product-details-nutrition-facts__list-item"
      >
        <VText
          class="product-details-nutrition-facts__list-item__title"
          font="caption-large-regular"
          tag="div"
          color="secondary"
        >
          {{ single.name }}
        </VText>
        <VText font="body-large-accent" tag="div">
          {{ single.value }}
        </VText>
      </div>
    </div>
  </section>
</template>

<style scoped lang="postcss">
.product-details-nutrition-facts {
  margin-top: var(--pl-unit-x4);

  @media (--pl-viewport-from-l) {
    margin-top: 0;
    margin-bottom: var(--pl-unit-x5);
  }

  &__title {
    margin-bottom: var(--pl-unit-x2);
  }

  &__list {
    display: flex;
    justify-content: space-around;
    border-radius: var(--pl-unit-x4);

    &-item {
      text-align: center;
      padding: 0 var(--pl-unit-x3);
      height: 48px;
      flex: 1;
      display: flex;
      flex-direction: column;
      min-width: 0;

      &__title {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;

        @media (--pl-viewport-from-m) {
          text-overflow: initial;
          overflow: initial;
          white-space: initial;
        }
      }

      &:not(:last-child) {
        border-right: 1px solid var(--pl-border-secondary-default);
      }

      @media (--pl-viewport-from-m) {
        padding: var(--pl-unit-x3);
        height: inherit;
      }
    }
  }
}
</style>
